const BuildingDetail = () => {
  return <> view detail</>;
};

export default BuildingDetail;
